import { render } from "./tabList.vue?vue&type=template&id=58297183"
import script from "./tabList.vue?vue&type=script&lang=js"
export * from "./tabList.vue?vue&type=script&lang=js"
script.render = render

export default script